import React from 'react'
import { M_DrawerTableTextField, M_CheckBox, M_InputTextField } from 'src/components/M_Components'

export default function ShippingInformation({ optionsShippingInformation, shippingInformation, setShippingInformation, createStructure, t }) {

    return (
        <div className='divCardSmall'>
            <div className='divTitleCard'>
                <div className='divSizeTitle'>
                    <div className='iconTitleCard'>
                        <img src="/icons/svgsDaNet/ship.svg"
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                            alt="Ship"
                        />
                    </div>
                    <div className='labelTitleCard'>
                        {t("ShippingInformation")}
                    </div>
                </div>
            </div>
            <div className='divDsiplayInputsShippingInformation'>
                {optionsShippingInformation.filter((elem) => elem.IsHiddenList !== true).map((elem5, key5) => (
                    <div key={key5}>
                        {elem5.IsForeignKey ? (
                            <M_DrawerTableTextField
                                tableLabel={elem5.NormalizedName}
                                label={elem5.NormalizedName}
                                required={elem5.IsRequired}
                                entity={elem5.ForeignTableName}
                                value={shippingInformation[elem5.ForeignTableToPassId] ? 
                                    {
                                        [elem5.ForeignTableToPassId]: shippingInformation[elem5.ForeignTableToPassId],
                                        [elem5.ForeignKeyName]: shippingInformation[elem5.Name]
                                    } : null}
                                filterField={elem5.ForeignKeyName}
                                labelFields={[elem5.ForeignKeyName]}
                                onSubmitValue={obj => {
                                    let updatedShippingInformation = { ...shippingInformation }
                                    if (obj) {
                                        updatedShippingInformation[elem5.Name] = obj[elem5.ForeignKeyName]
                                        updatedShippingInformation[elem5.ForeignTableToPassId] = obj[elem5.ForeignTableToPassId]
                                    } else {
                                        updatedShippingInformation[elem5.Name] = null
                                        updatedShippingInformation[elem5.ForeignTableToPassId] = null
                                    }
                                    setShippingInformation(updatedShippingInformation)
                                }}
                                disabled={elem5.disable}
                                valueField={elem5.ForeignTableToPassId}
                            />
                        ) : elem5.Type === 'string' ? (
                            <M_InputTextField
                                type={"text"}
                                label={elem5.NormalizedName}
                                required={elem5.IsRequired}
                                disabled={elem5.disable}
                                onChange={(e) => createStructure(e.target.value, elem5.Name, 'ShippingInformation')}
                                value={shippingInformation[elem5.Name] || ""} 
                            />
                        ) : elem5.Type === 'boolean' ? (
                            <div className='divCheckboxFormQuotes'>
                                <M_CheckBox
                                    label={elem5.NormalizedName}
                                    onChange={(e) => createStructure(e.target.checked, elem5.Name, 'ShippingInformation')}
                                    checked={shippingInformation[elem5.Name] || false} 
                                    required={elem5.IsRequired}
                                />
                            </div>
                        ) : "" }
                    </div>
                ))}
            </div>
        </div>
    )
}
